import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { Container, Segment, Grid, List, Button, Icon, Image } from 'semantic-ui-react'
import { isAuthenticated } from '../services/self'
import { confirmMarketplaceSubscription } from '../services/api-catalog'
import { getQueryString } from '../services/misc'
import ContactUs from '../components/ContactUs/ContactUs';

import cloudServices from './Images/services.png'
import cloudWatch from './Images/analysis.png'
import howItWorks from './Images/payment.png'
import consultancy from './Images/team.png'

export default class HomePage extends PureComponent {
  constructor(props) {
      super(props);
      this.state = {}
  }

  componentDidMount() {
    if(this.props.registerOpened) {
        this.openRegister();
    }
  }
  openRegister = () => document.getElementById("loginButton").click()

  render() {
    return (
      <div>
          <Segment padded className="block">
            <Container>
                <Grid stackable columns={2} relaxed>
                    <Grid.Column>
                        <Image src={cloudServices} style={{padding: '3em'}}/>
                    </Grid.Column>
                    <Grid.Column className="text">
                        <h1>Envimation as AWS Marketplace SaaS</h1>
                        <h2>AWS Native ready-to-run solutions providing</h2>
                        <List relaxed>
                            <List.Item>
                                <List.Icon name="line chart"/>
                                <List.Content>
                                    Monitoring using CloudWatch dashboards
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Icon name="bell outline"/>
                                <List.Content>
                                    Coming soon: Alerting using CloudWatch Alarms
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Icon name="settings"/>
                                <List.Content>
                                    Easy integration with your delivery system
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Icon name="money"/>
                                <List.Content>
                                    Pay on per-request base together with your AWS Bill
                                </List.Content>
                            </List.Item>
                            {/*<List.Item>*/}
                                {/*/!*<List.Icon name="users"/>*!/*/}
                                {/*<List.Content>*/}
                                    {/*Learn about features we offer by exploring our*/}
                                {/*</List.Content>*/}
                            {/*</List.Item>*/}
                        </List>
                    </Grid.Column>
                </Grid>
              </Container>
          </Segment>
          <Segment padded className="block">
              <Container>
                  <Grid stackable columns={2} relaxed>
                      <Grid.Column textAlign="right" width={4} className="text">
                          <Image style={{paddingTop: '2em'}} src={howItWorks}/>
                      </Grid.Column>
                      <Grid.Column width={10} className="text">
                          <h1>How does it work?</h1>
                          {/*<h2>Follow some simple steps and </h2>*/}
                          <List relaxed>
                              <List.Item>
                                  <List.Icon name="amazon"/>
                                  <List.Content>
                                      Hit Subscribe on AWS Marketplace
                                  </List.Content>
                              </List.Item>
                              <List.Item>
                                  <List.Icon name="handshake"/>
                                  <List.Content>
                                      Register and receive your unique API Token
                                  </List.Content>
                              </List.Item>
                              <List.Item>
                                  <List.Icon name="repeat"/>
                                  <List.Content>
                                      Use the API token to make HTTP requests to our endpoints
                                  </List.Content>
                              </List.Item>
                              <List.Item>
                                  <List.Icon name="check"/>
                                  <List.Content>
                                      Let our services setup the AWS features for you
                                  </List.Content>
                              </List.Item>

                              <Button primary animated className="envi" as={Link} to="https://aws.amazon.com/marketplace/pp/B079VCQ2T8" target="_blank">
                                  <Button.Content visible>AWS Marketplace</Button.Content>
                                  <Button.Content hidden><Icon name='arrow right'/></Button.Content>
                              </Button>

                          </List>
                      </Grid.Column>
                  </Grid>
              </Container>
          </Segment>
          <Segment padded className="block">
              <Container>
                  <Grid stackable columns={2} relaxed>
                      <Grid.Column textAlign="right" width={4} className="text">
                          <Image style={{paddingTop: '2em'}} src={cloudWatch}/>
                      </Grid.Column>
                      <Grid.Column width={10} className="text">
                          <h1>CloudWatch Dashboards</h1>
                          <p>As <em>a user of AWS</em>, I want <em>to visualise the extensive performance data provided by AWS out of the box</em> so that I:</p>
                          <List relaxed>
                              <List.Item>
                                  <List.Icon name="search"/>
                                  <List.Content>
                                      have visibility of my AWS EC2 instances
                                  </List.Content>
                              </List.Item>
                              <List.Item>
                                  <List.Icon name="amazon"/>
                                  <List.Content>
                                      don't have to invest into setting up 3rd party statistics storage and visualization tools
                                  </List.Content>
                              </List.Item>
                              <List.Item>
                                  <List.Icon name="time"/>
                                  <List.Content>
                                      don't need to spend time learning details about CloudWatch Dashboards' syntax
                                  </List.Content>
                              </List.Item>
                              <List.Item>
                                  <List.Icon name="repeat"/>
                                  <List.Content>
                                      don't need to update dashboards manually every time my infrastructure changes
                                  </List.Content>
                              </List.Item>
                              <Button primary animated className="envi" as={Link} to="/getting-started">
                                  <Button.Content visible>Get started now!</Button.Content>
                                  <Button.Content hidden><Icon name='arrow right' /></Button.Content>
                              </Button>
                          </List>
                      </Grid.Column>
                  </Grid>
              </Container>
          </Segment>
          <Segment padded className="block">
              <Container>
                  <Grid stackable columns={2} relaxed>
                      <Grid.Column textAlign="right" width={4} className="text">
                          <Image style={{paddingTop: '2em'}} src={consultancy}/>
                      </Grid.Column>
                      <Grid.Column width={10} className="text">
                          <h1>Didn't find the automation you were looking for?</h1>
                          <h3>Our team is constantly working on enriching our endpoint profile.<br/>
                              <ContactUs>Contact us</ContactUs> to request the features you need for your team!</h3>
                          <h3>We also provide</h3>
                          <List relaxed>
                              <List.Item>
                                  <List.Icon name="cloud"/>
                                  <List.Content>
                                      Consultancy in CloudComputing and Automation
                                  </List.Content>
                              </List.Item>
                              <List.Item>
                                  <List.Icon name="lab"/>
                                  <List.Content>
                                      Developing software solutions meeting your needs
                                  </List.Content>
                              </List.Item>
                              <Button primary animated className="envi" as={Link} to="https://envimate.com" target="_blank">
                                  <Button.Content visible>Visit Envimate</Button.Content>
                                  <Button.Content hidden><Icon name='arrow right' /></Button.Content>
                              </Button>
                          </List>
                      </Grid.Column>
                  </Grid>
              </Container>
          </Segment>
      </div>

    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/Home.js
 **/